import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

export interface FlowchartRemoveNodeModalProps {
  nodeNames: Array<string>;
  onRequestRemove: () => void;
  onRequestClose: () => void;
}

export default function FlowchartRemoveNodeModal(props: FlowchartRemoveNodeModalProps): JSX.Element {
  const {nodeNames, onRequestRemove, onRequestClose} = props;

  const isSingleNode = nodeNames.length === 1;

  const renderMessage = (): JSX.Element => {
    if (isSingleNode) {
      return (
        <p className={css(styles.message)}>
          Removing <strong>{nodeNames[0]}</strong> will also remove all connections to or from it.
        </p>
      );
    }

    return (
      <>
        <p className={css(styles.message)}>
          Removing these items will also remove all connections to or from them:
        </p>
        <ul className={css(styles.list)}>
          {nodeNames.map((name, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      </>
    );
  };

  return (
    <Modal
      title="Remove from flowchart?"
      flexContent={true}
      buttons={[
        {
          text: 'Cancel',
          submit: false,
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: () => {
            onRequestClose();
          },
        },
        {
          text: 'Remove',
          submit: true,
          style: ButtonStyle.NEGATIVE,
        },
      ]}
      onRequestSubmit={() => {
        onRequestRemove();
        onRequestClose();
      }}
      onRequestClose={onRequestClose}
    >
      <div className={css(styles.content)}>{renderMessage()}</div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  content: {
    fontSize: '14px',
  },
  message: {
    margin: 0,
    lineHeight: '20px',
  },
  list: {
    margin: '8px 0 0 0',
    paddingLeft: '20px',
    lineHeight: '20px',
  },
});
